import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 12 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_9578_1187)" }, [
      _createElementVNode("path", {
        d: "M11 4.83398L6 9.83398L1 4.83398L11 4.83398Z",
        fill: "#522BD6",
        stroke: "#522BD6",
        "stroke-width": "1.25",
        "stroke-linejoin": "round"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "clip0_9578_1187" }, [
        _createElementVNode("rect", {
          width: "12",
          height: "12",
          fill: "white",
          transform: "translate(12 0.5) rotate(90)"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }